import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import QuizFunnel from "@/pages/QuizFunnel";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ListenPage from "@/pages/ListenPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App font-body">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/quiz" element={<QuizFunnel />} />
          <Route path="/success" element={<PaymentSuccess />} />
          <Route path="/listen/:orderId" element={<ListenPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
